import styled from 'styled-components'


export const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
`

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 8px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const SecondaryAction = styled.div`
  display: flex;
  align-items: center;
  min-width: fit-content;

  @media (max-width: 640px) {
    justify-content: center;
  }
`

export const ForgotPassword = styled.a`
  color: #2d749c;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.18s ease;

  &:hover {
    color: #c6016b;
  }
`

export const ErrorText = styled.p`
  color: #c93b55;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  margin-top: 10px;
`
